import { Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-checkpoint-select-role-to-notify-dialog',
    templateUrl: './checkpoint-select-role-to-notify-dialog.component.html',
    styleUrls: ['./checkpoint-select-role-to-notify-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CheckpointSelectRoleToNotifyDialogComponent extends FiDialogsContentBase<
    { rolesToNotify: any[] },
    number
> {
    selectedRoleId: number;

    isYesButtonDisabled() {
        return !this.selectedRoleId;
    }

    getResult() {
        return this.selectedRoleId;
    }
}
